import React from "react";
import { TrustPill } from "../TrustPill";
import type { FreshnessSurface } from "../../lib/executive-seo-types";

interface FreshnessTableProps {
  surfaces: FreshnessSurface[];
}

function relTime(iso: string | null): string {
  if (!iso) return "—";
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return iso;
  const days = (Date.now() - t) / 86_400_000;
  if (days < 1) return `${(days * 24).toFixed(0)}h ago`;
  if (days < 30) return `${days.toFixed(0)}d ago`;
  return iso.slice(0, 10);
}

export function FreshnessTable(props: FreshnessTableProps): React.ReactElement {
  return (
    <div className="overflow-x-auto bg-white rounded-xl border border-ink-100 shadow-sm">
      <table className="w-full text-sm">
        <thead className="bg-ink-50 text-xs uppercase tracking-wider text-ink-600">
          <tr>
            <th className="text-left px-4 py-2">Surface</th>
            <th className="text-left px-4 py-2">Latest</th>
            <th className="text-right px-4 py-2">Rows</th>
            <th className="text-right px-4 py-2">Sites</th>
            <th className="text-left px-4 py-2">Trust</th>
            <th className="text-left px-4 py-2">Caveat</th>
          </tr>
        </thead>
        <tbody>
          {props.surfaces.map((s) => (
            <tr key={s.surface} className="border-t border-ink-100">
              <td className="px-4 py-2 font-mono text-xs">{s.surface}</td>
              <td className="px-4 py-2 text-ink-700">{relTime(s.latest)}</td>
              <td className="px-4 py-2 text-right">{s.rows.toLocaleString()}</td>
              <td className="px-4 py-2 text-right">{s.sites.toLocaleString()}</td>
              <td className="px-4 py-2"><TrustPill label={s.trustLabel} /></td>
              <td className="px-4 py-2 text-xs text-ink-600">{s.trustLabel?.caveat ?? s.trustLabel?.reason ?? ""}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
